import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { FileService } from 'app/_services/file.service';
import { SiteWorkOrderProceduresService } from 'app/_services/site-work-order-procedures.service';
import { ContractorService } from 'app/_services/contractor.service';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';
import { SortEvent } from 'primeng/api';

@Component({
  selector: 'oem-work-order-procedures',
  templateUrl: './oem-procedures.component.html',
})
export class OemProceduresComponent implements OnInit {
  public selectedContractorId: any;
  public procedures: any = [];
  public selectedContractor: any;
  public selectedProcedure: any;
  public routeRole: any;
  public tabitems: any[] = [];
  public role: any;

  // pagination
  public pageSizes: any = environment.pageSizes;
  public pagination: any;
  @ViewChild('paginator', { static: true }) paginator;

  // Sorting and Filtering
  defaultSortField = 'name';
  selectedSort = [ this.defaultSortField + ',asc' ];

  public isFilterLoading: boolean;
  private filters = [
    { key: 'idFilter', value: '' },
    { key: 'nameFilter', value: '' },
    { key: 'descriptionFilter', value: '' },
  ];

  public saveInProgress = false;

  public selectedDocuments: any[] = [];
  public isViewProcedureDocumentsModalShown: boolean;
  public isAddDocumentsToProcedureModalShown: boolean;
  public allowWorkOrderScheduling: boolean;
  public allowAssetScheduling: boolean;

  constructor(
    private globals: Globals,
    private contractorService: ContractorService,
    private procedureService: SiteWorkOrderProceduresService,
    private fileService: FileService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {

    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;

    if(this.routeRole === 'contractor-manager'){
      this.tabitems = [
        { path: '/' + this.routeRole + '/company/details', title: 'Details' },
        { path: '/' + this.routeRole + '/company/contacts', title: 'Contacts' },
        { path: '/' + this.routeRole + '/company/certificates', title: 'Certificates' },
        { path: '/' + this.routeRole + '/company/procedures', title: 'Procedures' },
      ];
      this.selectedContractorId = globals.contractor.maintenanceId;
    } else {
      this.activatedRoute.params.subscribe((params: Params) => {
        this.selectedContractorId = params.id;
      });
      this.tabitems = [
        { path: '/' + this.routeRole + '/contractors/', title: 'All Contractors', class: 'back-link' },
        { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/details', title: 'Details' },
        { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/workers', title: 'Workers' },
        { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/certificates', title: 'Certificates' },
        { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/contacts', title: 'Contacts' },
        { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/procedures', title: 'Procedures' },
      ];

    }
  }
  // Page Load
  ngOnInit(): void {
    this.getSelectedContractor(this.selectedContractorId);
    this.resetPagination(); // call service to populate table
  }

  public getSelectedContractor(id) {
    this.contractorService.getContractorById(id).subscribe((data: any) => {
      this.selectedContractor = data;
    });
  }

  private getAllWorkerOrderProcedures() {
    this.procedureService.getAllWorkOrderProceduresByContractor(this.selectedContractorId, this.pagination, this.selectedSort, this.filters).subscribe((data: any) => {
      this.procedures = [];
      for (let i = 0; i < data.body.length; i++) {
        this.procedures.push(data.body[i]);
      }
      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
      this.isFilterLoading = false;
    });
  }

  //
  // Table actions
  public paginate(event: any): void {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllWorkerOrderProcedures();
  }

  private resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();

    this.getAllWorkerOrderProcedures();
  }

  public customSort(sort: SortEvent) {
    let sortDirection: String = 'asc';

    if (sort.order === -1) {
      sortDirection = 'desc';
    }
    this.selectedSort = [ sort.field + ',' + sortDirection ];

    this.goToFirstPage();

    this.getAllWorkerOrderProcedures();
}

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }

  public onFilterTextChanged(filterText: string, filterField: string){
    this.isFilterLoading = true;

    if (filterField === 'idFilter') {
      filterText = filterText.replace(/PRC/gi, '');
    }

    this.filters.find(filter => filter.key === filterField).value = filterText;

    this.goToFirstPage();
    this.getAllWorkerOrderProcedures();
  }

  public async onRowSelect(event) {
    this.selectedProcedure = event.data;
    const { value: action } = await Swal.fire({
      title: 'PRC' + event.data.id,
      input: 'select',
      inputOptions: {
        edit: 'Edit',
        view: 'View Documents',
        uploadDocs: 'Upload Documents',
        delete: 'Delete',
      },
      onOpen: () => {
        const input = Swal.getInput();
        input.oninput = () => {
          Swal.clickConfirm();
        };
      },
      inputPlaceholder: 'Select an option',
      showCancelButton: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          resolve(null);
        });
      },
    });

    if (action) {
      if (action === 'edit') {
        this.editWorkOrderProcedure();
      } else if (action === 'delete') {
        this.deleteWorkOrderProcedure();
      } else if (action === 'uploadDocs') {
        this.showUploadDocumentsModal();
      } else if (action === 'view') {
        this.showViewAndDeleteDocumentsModal();
      } else {
        console.log('No valid option selected');
      }
    }
  }

  //
  // Create Procedure
  //
  public showCreateProcedureModal() {
    this.router.navigate(['create-procedure'], { relativeTo: this.activatedRoute });
  }

  //
  // Edit Procedure
  //
  private editWorkOrderProcedure() {
    this.router.navigate(['edit-procedure', this.selectedProcedure.id], { relativeTo: this.activatedRoute });
  }

  //
  // Delete Procedure
  //

  private deleteWorkOrderProcedure() {
    Swal.fire({
      title: 'Delete Procedure?',
      text: 'You will not be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'confirm-danger',
      },
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.value) {
        this.procedureService.deleteWorkOrderProcedure(this.selectedProcedure.id).subscribe((data: any) => {
          this.getAllWorkerOrderProcedures();
          Swal.fire('Deleted!', 'Procedure has been removed.', 'success');
        });
      }
    });
  }

  //
  // Documents
  //

  private showViewAndDeleteDocumentsModal() {
    this.isViewProcedureDocumentsModalShown = true;
  }

  public viewDocument(fileName: string): void {
    this.fileService.showFile(this.globals.fileFolder.workOrderProcedureFiles, fileName);
  }

  public deleteDocument(fileId): void {
    this.fileService.deleteFile(fileId);
    this.isViewProcedureDocumentsModalShown = false;
    Swal.fire({
      title: 'Delete RAMS Document?',
      text: 'Are you sure? This action cannot be reverted!',
      type: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'confirm-danger',
      },
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.value) {
        this.fileService.deleteFile(fileId).subscribe((data: any) => {
          this.getAllWorkerOrderProcedures();
          Swal.fire('Deleted!', 'Procedure RAMS Document has been deleted.', 'success');
        });
      }
    });
  }

  public onFileChange(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      this.selectedDocuments.push(file);
    }
  }

  private showUploadDocumentsModal() {
    this.selectedDocuments = [];
    this.isAddDocumentsToProcedureModalShown = true;
  }

  public onAddDocumentsSubmit(): void {
    this.saveInProgress = true;
    const procedure = {
      id: this.selectedProcedure .id,
      documents: this.selectedDocuments,
    };

    this.procedureService.addDocumentsToProcedure(procedure).subscribe(() => {
      this.saveInProgress = false;
      this.isAddDocumentsToProcedureModalShown = false;
      this.getAllWorkerOrderProcedures();
      Swal.fire('Uploaded!', 'Additional procedure documents have been uploaded.', 'success');
    });
  }
}
